import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { View, FlatList, useWindowDimensions, StyleSheet } from 'react-native';
import { ActivityIndicator, Card } from 'react-native-paper';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomButton from '../../../components/CustomButton';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';
import { useTableHelper } from '../../../hooks/useTableHelper';
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledDropdown from '../../../components/ControlledComponents/CustomControlledDropdown';

//#region Render Flatlist
const FlatListView = React.memo(({ item, styles, t, convertDate, handleDelete,
    modal, control, setValue, setStatus, index, reviewers, seniorityLevels, colors
}) => {
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedData, setSelectedData] = useState([]);

    useEffect(() => {
        let dop = selectedData?.startDate === '' ? '' : convertDate(selectedData?.startDate);
        if (dop === '') {
            setStatus('enterDate')
        }
        setValue(`${item.rowguid}.dop`, dop)
    }, [selectedData])

    useEffect(() => {
        let dop = item?.dop;
        if (dop !== '' && dop !== null) {
            setSelectedData({ startDate: dop });
        } else if (dop === '') {
            setSelectedData({ startDate: '' });
        } else {
            setSelectedData([]);
        }
    }, [item.dop]);


    const onShowCalendarPress = (key) => {
        setShowCalendar(!showCalendar)
    }

    return (
        <SafeAreaView>
            <SafeAreaView style={styles.row}>
                <View style={[styles.item]}>
                    <CustomLabel value={t(`common:dateOfPromotion`)} type='SUBTITLE' />
                    <SafeAreaView style={styles.row}>
                        <CustomControlledInput
                            name={`${item.rowguid}.dop`}
                            control={control}
                            editable={false}
                            type={selectedData?.startDate === '' || selectedData?.startDate === null ? 'EDIT_EMPLOYEE_REQUIRED' : 'MAININPUT'}
                            rules={{
                                required: t('common:dateOfPromotionReqMess'),
                            }}
                        />
                        <Ionicons
                            name={showCalendar ? "calendar" : "calendar-outline"}
                            style={styles.icons}
                            onPress={() => onShowCalendarPress(true)}
                        />
                    </SafeAreaView>
                </View>
                <View style={[styles.item]}>
                    <SafeAreaView>
                        <CustomLabel value={`${t(`common:from`)} ${t(`common:seniorityLevel`)}`} type='SUBTITLE' />
                        <CustomControlledDropdown
                            multipleSelect={true}
                            control={control}
                            name={`${item.rowguid}.hcodeOld`}
                            type="TIMESHEET"
                            options={seniorityLevels}
                            setValue={setValue}
                        />
                    </SafeAreaView>
                </View>
                <View
                    style={[styles.item]}>
                    <SafeAreaView>
                        <CustomLabel value={`${t(`common:to`)} ${t(`common:seniorityLevel`)}`} type='SUBTITLE' />
                        <CustomControlledDropdown
                            multipleSelect={true}
                            control={control}
                            name={`${item.rowguid}.hcodeNew`}
                            type="TIMESHEET"
                            options={seniorityLevels}
                            setValue={setValue}
                        />
                    </SafeAreaView>
                </View>
                <SafeAreaView style={styles.item}>
                    <CustomLabel value={t('common:reviewer')} type='SUBTITLE' />
                    <CustomControlledDropdown
                        multipleSelect={true}
                        control={control}
                        name={`${item.rowguid}.reviewer`}
                        type="TIMESHEET"
                        options={reviewers}
                        setValue={setValue}
                    />
                </SafeAreaView>
                <View style={styles.verticalLine} />
                <CustomButton
                    iconName={"trash-outline"}
                    onPress={() => {
                        handleDelete(item, index, 'rowguid', modal)
                    }}
                    show='PART'
                    type='PART'
                    textTop='0'
                    sz={30} />
                <SafeAreaView style={styles.justMargin}></SafeAreaView>
            </SafeAreaView>
            {showCalendar &&
                <SafeAreaView style={styles.secondLine}>
                    {/* calendar view */}
                    <View style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 10,
                        borderWidth: 0,
                        borderColor: colors.border_card,
                    }}>
                        <CustomCalendar
                            calendarType={'RangePicker'}
                            setRange={setSelectedData}
                            range={selectedData}
                            allowSingleDate={true}
                            startingYear={1950}
                        />
                    </View>
                </SafeAreaView>
            }
        </SafeAreaView>

    )
});
//#endregion

const HRAdminPromotionHistory = ({ props }) => {
    const { selectedEmployee, convertDate, flatlistEditPress = false, styles, common, emplCopmany,
        modal, t, getDropdownValues, dropdowns, employmentTabData,
        renameKeysInOptions, selectedCompany, modalVisible, setModalVisible, colors, rowguid, dept, doa, setShowPromHist
    } = props;
    const ref = useRef(null);
    const { width, height } = useWindowDimensions();
    const [changes, setChanges] = useState([]);
    const { getPromHist, insertPromHist, updatePromHist, deletePromHist } = useHRAdminEmployees();
    const { handleCancelChanges, rowAdd, rowDelete } = useTableHelper();
    const [deletedItems, setDeletedItems] = useState([]);
    const [insertData, setInsertData] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const { control, handleSubmit, formState: { errors }, getValues, setValue, unregister, register } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);

    //#region Get Dropdowns & PromotionHistory Data
    const [emplDepts, setEmplDepts] = useState([]);
    const [originalEmplDepts, setOriginalEmplDepts] = useState([]);
    const [reviewers, setReviewers] = useState([]);
    const [seniorityLevels, setSeniorityLevels] = useState([]);
    const sParams = [
        { seniorityLevels: { sFilt1: props.emplCompany, sFilt2: "", sFilt3: "" } },
        { reviewers: { sFilt1: "", sFilt2: "", sFilt3: "" } }
    ];

    useEffect(() => {
        setIsLoading(true);
        setState('loading');
        getDropdownValues(sParams).then((res) => {
            setSeniorityLevels(renameKeysInOptions(res?.seniorityLevels));
            setReviewers(renameKeysInOptions(res?.reviewers));
            getPromHist(selectedEmployee?.employeeID, props.emplCompany, rowguid, dept).then((res) => {
                let empldepts = res?.data;
                empldepts.forEach(dept => {
                    dept['dop'] = dept['dop']?.split('T')[0];
                });
                setEmplDepts(empldepts);
                setOriginalEmplDepts(empldepts);

                empldepts.forEach((item, index) => {
                    Object.keys(item).forEach(key => {
                        setValue(`${item.rowguid}.${key}`, item[key]);
                    });
                });
                setState(null);
                setIsLoading(false);
            })
        })
    }, [])
    //#endregion 

    //#redion UseEffects
    useEffect(() => {
        let time = 10000
        if (state !== null) {
            if (state === 'allOperationsSuccMess') time = 2000
            setShowState(true);
            const timer = setTimeout(() => {
                if (state === 'allOperationsSuccMess') reloadData()
                setShowState(false);
                setState(null);
            }, time);

            return () => {
                clearTimeout(timer);
            };
        }
    }, [state]);

    useEffect(() => {
        if (emplDepts.length <= 0) return;
        let item = emplDepts[0];
        Object.keys(item).forEach(key => {
            register(`${item.rowguid}.${key}`);
        });
    }, [emplDepts, setValue]);
    //#endregion

    //#region Handle Actions functions
    const handleAddPress = () => {
        let exceptions = ["doa", "dept", "jobTitle", "employmentContext", "seniority", "dot"];
        rowAdd(emplDepts, setEmplDepts, exceptions, [], ref, t, [], [], changes, setChanges, insertData, setInsertData, id = 'rowguid');
    };

    const handleRemovePress = () => {
        handleCancelChanges(setEmplDepts, originalEmplDepts, setDeletedItems, setChanges, setDuplicates);
    };

    const closeModal = () => {
        props.onClose();
        setModalVisible(!modalVisible);
    }

    const handleDelete = (item, index, attribute, modal) => {
        rowDelete(item, index, attribute, changes, setChanges, emplDepts, setEmplDepts, setDeletedItems, ref);
        unregister(`items.${item.rowguid}`);
    }


    useEffect(() => {
        // If trying to delete all lines prevent it with message 
        if (deletedItems.length === 0) return;
        if (deletedItems.length === originalEmplDepts.length) {
            handleRemovePress()
            setState('cannotDeleteAllEntries')
        }
    }, [deletedItems])
    //#endregion

    //#region Submit Changes
    const onSubmit = (data) => {
        //let hasMultPrimaries = false;
        // To add company and convert date back to yyy-mm-dd
        if (!fixData(data)) return;
        let remainingObjects = [];
        for (const key in data) {
            if (key === 'undefined') { continue; }
            if (!insertData.includes(key) && !deletedItems.includes(key))
                remainingObjects.push(data[key])
        }
        const insertObjects = findObjects(data, insertData);
        submitData(insertObjects, remainingObjects, deletedItems)
    };

    const submitData = async (insertData, updateData, deleteData) => {
        let newPromises = [];
        let deleteSucc = true;
        let updateSucc = true;
        let insertSucc = true;
        let employeeid = selectedEmployee?.employeeID;

        //setIsLoading(true);
        //setState('saving');
        //Handle insert
        newPromises.push(
            insertPromHist(insertData, employeeid).then((res) => {
                if (res?.status === 200) {
                    insertSucc = true;
                } else {
                    insertSucc = false;
                }
                //Handle deletion
                newPromises.push(
                    deletePromHist(deleteData, employeeid).then((res) => {
                        if (res?.status === 200) {
                            deleteSucc = true;
                        } else {
                            deleteSucc = false;
                        }
                        newPromises.push(
                            updatePromHist(updateData, employeeid).then((res) => {
                                if (res?.status === 200) {
                                    updateSucc = true;
                                } else {
                                    updateSucc = false;
                                }
                            }).catch((e) => { console.error("Update Failed: ", e) })
                        )
                    }).catch((e) => { console.error("Delete Failed: ", e) })
                )
            }).catch((e) => { console.error("Insert Failed: ", e) })
        )
        try {
            await Promise.all(newPromises);
            if (deleteSucc && updateSucc && insertSucc) {
                setState('allOperationsSuccMess');
            } else {
                // Handle failure states as needed
                if (!updateSucc || insertSucc) setState('issueMessage');
                else if (!deleteSucc) setState('deleteFailed');
            }
            props.onPromotionHistoryUpdated();
        } catch (error) {
            setState('issueMessage')
            console.log(error);
        }
    };

    const reloadData = async () => {
        try {
            setIsLoading(true);
            setState('loading');
            getDropdownValues(sParams).then((res) => {
                setSeniorityLevels(renameKeysInOptions(res?.seniorityLevels));
                setReviewers(renameKeysInOptions(res?.reviewers));
                getPromHist(selectedEmployee?.employeeID, props.emplCompany, rowguid, dept).then((res) => {
                    let empldepts = res?.data;
                    empldepts.forEach(dept => {
                        dept['dop'] = dept['dop']?.split('T')[0];
                    });
                    setEmplDepts(empldepts);
                    setOriginalEmplDepts(empldepts);

                    empldepts.forEach((item, index) => {
                        Object.keys(item).forEach(key => {
                            setValue(`${item.rowguid}.${key}`, item[key]);
                        });
                    });
                    setDeletedItems([])
                    setInsertData([])
                    setState(null);
                    setIsLoading(false);
                })
            })
        } catch (error) {
            setState('issueReload');
            console.error('Failed to reload data:', error);
        }
    };

    const findObjects = (mainObject, rowguids) => {
        return rowguids.map(rowguid => {
            const innerObject = mainObject[rowguid];
            if (innerObject) {
                return {
                    ...innerObject, rowguid,
                    employeeID: selectedEmployee?.employeeID,
                    dept: dept,
                    // doa: convertDate(doa)
                    doa: doa
                };
            }
            return null;
        }).filter(item => item !== null);
    };

    const fixData = (data) => {
        Object.values(data).forEach(row => {
            //row["doa"] = row?.doa?.startDate;
            //row["dot"] = row?.dot?.startDate;
            row['dop'] = convertDateBack(row?.dop);
            row['company'] = props.emplCompany;
        });
        return true;
    };

    const convertDateBack = (inputDate) => {
        if (!inputDate) return;
        const [day, month, year] = inputDate.split('-');
        const date = new Date(year, month - 1, day);
        const isoDay = String(date.getDate()).padStart(2, '0');
        const isoMonth = String(date.getMonth() + 1).padStart(2, '0');
        const isoYear = date.getFullYear();
        return `${isoYear}-${isoMonth}-${isoDay}`;
    };
    //#endregion

    //#region Render Promotion Hist lines
    const renderEmplPromHist = ({ item, index }) => {
        return (
            <Card style={[common.cardstyle]}>
                <Card.Content>
                    <FlatListView
                        styles={styles}
                        control={control}
                        item={item}
                        index={index}
                        convertDate={convertDate}
                        handleDelete={handleDelete}
                        getValues={getValues}
                        setStatus={setState}
                        modal={modal}
                        setValue={setValue}
                        seniorityLevels={seniorityLevels}
                        reviewers={reviewers}
                        t={t}
                        colors={colors}
                    />
                </Card.Content>
            </Card>
        )
    }
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion


    return (
        <>
            <View style={styles.iconRow}>
                {modal?.allowsAddDelete && !isLoading ? (
                    <View style={styles.leftIcons}>
                        <Ionicons
                            name={"add-circle-outline"}
                            style={styles.icon}
                            onPress={handleAddPress}
                        />
                        <Ionicons
                            name={"remove-circle-outline"}
                            style={styles.icon}
                            onPress={handleRemovePress}
                        />
                    </View>
                ) : (
                    <View style={styles.leftIcons}></View>
                )}
                <View style={[styles.rightIcon, { flexDirection: 'row' }]}>
                    {state && showState && <CustomLabel
                        value={`${t('common:state')}: ${t(`common:${state}`)}`}
                        type={state === 'cannotDeleteAllEntries' || state === 'deleteFailed' || state === 'issueMessage' || state === 'enterDate'
                            ? 'EDIT_EMPLOYEE_BAD_STATE' : 'EDIT_EMPLOYEE_STATE'}
                    />}
                    <Ionicons
                        name={"arrow-back-outline"}
                        style={styles.icon}
                        onPress={() => {
                            setShowPromHist({ show: false, item: null });
                        }}
                    />
                    <Ionicons
                        name={"close-circle-outline"}
                        style={styles.icon}
                        onPress={closeModal}
                    />
                </View>
            </View>
            <FlatList
                style={{ height: height / 2, flexGrow: 0 }}
                data={emplDepts}
                keyExtractor={(item, index) => `${item?.rowguid}`}
                renderItem={renderEmplPromHist}
                scrollEnabled={true}
                refreshing={isLoading}
                ref={ref}
                initialNumToRender={10}
                ListHeaderComponent={
                    <CustomLabel
                        value={`${selectedEmployee?.name}'s ${t(`common:promHistTitle`)}`}
                        type='SUBTITLE'
                    />
                }
                ListEmptyComponent={
                    isLoading ? (
                        <View style={promHistStyles.container}>
                            <ActivityIndicator animating={true} color={colors.blue} />
                        </View>) : (
                        <CustomLabel
                            value={t("common:promHistLoadingPreview")}
                            type="NO_BRANCHES"
                        />
                    )
                }
            />
            {!isLoading &&
                <View style={[styles.functionalityButtons]}>
                    <CustomButton
                        text={t('common:saveChanges')}
                        onPress={handleSubmit(onSubmit)}
                        type='BUTTON_SAVE'
                        isGradient={true}
                        textTop='0'
                        sz={15}
                    />
                </View>
            }
        </>
    );
};

const promHistStyles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});


export default HRAdminPromotionHistory;